import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Gift, Trophy, HelpingHand, Receipt, Users, Star } from "lucide-react";
import api, { fmtINR } from "@/lib/api";

const BENEFITS = [
  { key: "entry_gift", icon: Gift, title: "Special Entry Gift", desc: "₹100 welcome reward credited on signup", tone: "rose" },
  { key: "lucky_draw_cashback", icon: Trophy, title: "Lucky Draw Contest", desc: "50-member groups, 6-month criteria, 50% cashback to winner", tone: "amber" },
  { key: "premium_finance_support", icon: HelpingHand, title: "Premium Finance Support", desc: "Request short-term help to pay premiums with low interest", tone: "indigo" },
  { key: "first_premium_cashback", icon: Receipt, title: "First Premium Cashback", desc: "25% cashback on your first premium contribution", tone: "emerald" },
  { key: "referral_income", icon: Users, title: "Referral Income", desc: "Earn ₹500 for every successful referral", tone: "cyan" },
  { key: "special_agent_share", icon: Star, title: "Special Agent Share", desc: "20% bonus share yearly when referral targets achieved", tone: "violet" },
];

const tones = {
  amber: "from-amber-400 to-orange-500", emerald: "from-emerald-400 to-emerald-600",
  rose: "from-rose-400 to-pink-500", indigo: "from-indigo-400 to-blue-600",
  cyan: "from-cyan-400 to-sky-600", violet: "from-violet-500 to-purple-700",
};

export default function Benefits() {
  const nav = useNavigate();
  const [b, setB] = useState({});

  useEffect(() => { api.get("/customer/benefits").then((r) => setB(r.data)); }, []);

  return (
    <div data-testid="benefits-page">
      <div className="bg-tenant-gradient text-white px-5 pt-6 pb-8 rounded-b-[2rem]">
        <div className="flex items-center gap-3">
          <button data-testid="header-back" onClick={() => nav(-1)} className="w-9 h-9 rounded-full bg-white/15 grid place-items-center">
            <ArrowLeft className="w-4 h-4" />
          </button>
          <div>
            <div className="font-extrabold tracking-tight text-lg">6 Benefits</div>
            <div className="text-[11px] opacity-80">Earn more as you save daily</div>
          </div>
        </div>
      </div>

      <div className="px-5 mt-4 space-y-3">
        {BENEFITS.map((bn, i) => (
          <div key={bn.key} data-testid={`benefit-card-${bn.key}`} className="bg-white border border-slate-100 rounded-3xl p-4 card-shadow flex gap-4">
            <div className={`shrink-0 w-14 h-14 rounded-2xl bg-gradient-to-br ${tones[bn.tone]} text-white grid place-items-center shadow-md`}>
              <bn.icon className="w-7 h-7" strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-bold text-slate-400">#{i + 1}</span>
                <div className="font-extrabold tracking-tight text-base">{bn.title}</div>
              </div>
              <div className="text-[12px] text-slate-500 mt-1 leading-snug">{bn.desc}</div>
              <div className="mt-2 flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-wider font-bold text-slate-400">Earned</span>
                <span className="font-extrabold text-emerald-600 text-sm">{fmtINR(b[bn.key] || 0)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="h-10" />
    </div>
  );
}
